import { Text, TextProps } from '@mantine/core';
import { MChatMessage } from '@/src/modules/chat/models/chat-message';

interface IChatConversationLastMessageProps {
  message: MChatMessage;
  overrideInteloctorName?: string;
}

const textProps: TextProps = {
  fz: 'xs',
  lineClamp: 1,
  c: 'dimmed',
};

export function ChatConversationLastMessage({
  message,
  overrideInteloctorName,
}: IChatConversationLastMessageProps) {
  const intelocutorName =
    overrideInteloctorName ?? message.props.sender.props.name;

  if (message.props.content) {
    return (
      <Text {...textProps}>
        {message.props.fromMe ? 'Anda' : intelocutorName}:{' '}
        {message.props.content}
      </Text>
    );
  }

  return (
    <Text {...textProps}>
      {message.props.fromMe ? 'Anda' : intelocutorName}: Mengirim attachment
    </Text>
  );
}
